import { render, staticRenderFns } from "./SingleViewContent.vue?vue&type=template&id=7a56d35e&"
import script from "./SingleViewContent.vue?vue&type=script&lang=js&"
export * from "./SingleViewContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports